import { MenuOption } from "./menu-option";

export class MenuOptionHolder{
    public SectionName:string = "";
    public Options:MenuOption[] = [];
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}